import { LocalStorageKey, setLocalStorage } from "@/features/LocalStorage";
import { useCallback, useEffect } from "react";
import { MetricQuery } from "./metrics.types";
import { metricStackAtom } from "./metrics.state";
import { useAtom } from "jotai";

export function useMetricStack() {
    const [stack, setStack] = useAtom(metricStackAtom);

    useEffect(() => {
        setLocalStorage(LocalStorageKey.MetricLab, {
            metricStack: stack,
        });
    }, [stack]);

    const appendToStack = useCallback(
        (query: MetricQuery) => {
            const filteredStack = stack.filter(
                (item) => item.metricQuery !== query.metricQuery,
            );
            setStack([query, ...filteredStack]);
        },
        [setStack, stack],
    );

    return { stack, appendToStack, setStack };
}
